
import { Component, Vue, Watch } from "vue-property-decorator";
import UiAccordion from "@/components/Main/Ui/UiAccordion.vue";
import UiStep from "@/components/Main/Ui/UiStep.vue";
import EthicsCodexModal from "@/components/Main/EthicsCodexModal.vue";
import { dispatchSubmitResidentAgreement, dispatchGetResidentAgreement, dispatchUpdateResidentAgreement } from "@/store/mlm/actions";
import { dispatchGetUserProfile } from "@/store/main/actions"
import { dispAuthFetch } from "@/store/mlm/actions";
import { readUserProfile } from "@/store/main/getters";
import ResidentStatus from "./ResidentStatus.vue";
import ClientInfo from "@/views/main/profile/ClientInfo.vue";
import {USER_ROLES} from '@/constants';
@Component({
  components: {
    ResidentStatus,
    UiAccordion,
    UiStep,
    EthicsCodexModal,
    ClientInfo,
  },
})
class ResidentRules extends Vue {
  // Vuelidate instance
  public $v!: any;
  public showECodexModal = false;
  public residentAgreementStatus = "";
  public openAccordeonIndex: number | null = null;

  public isShowAddSocialNetwork = false;
  public skipAllSocialNetworks = false;

  public residentAgreementModifyReason = "";
  public statusCheckInterval: number | null = null;
  public previousResidentAgreementStatus: string | null = null;
  public isLoadingStatus = true;

  public socialNetworkList = [
  {value: 'Instagram', label: 'Instagram'},
  {value: 'Telegram', label: 'Telegram channel/chat'},
  {value: 'TikTok', label: 'TikTok'},
  {value: 'YouTube', label: 'YouTube'},
  {value: 'VK', label: 'VK'},
  {value: 'OK', label: 'OK'},
  {value: 'Rutube', label: 'Rutube'},
  {value: 'X', label: 'X'},
  {value: 'Discord', label: 'Discord'},
  {value: 'LinkedIn', label: 'LinkedIn'},
  {value: 'Threads', label: 'Threads'},
  {value: 'Another', label: 'Another'},
];

public countryList: {code: string, name: string}[] = [];
  public residentAgreementRequestId = null;
  public formData = {
    name: '',
    surname: '',
    country: '',
    email: '',
    socials: [] as Array<{type: string, value: string, skip: boolean}>
  };

  public additionalSocials: Array<{type: string, value: string, customName: string}> = [];

  public isConfirmStep3 = false;
  public showTgUsernameWarning = false;
  public isConfirmStep4 = false;
  public showTelegramBotWarning = false;
  public isConfirmStep6 = false;
  public isConfirmStep7 = false;

  public isConfirmStep8 = false;
  public isConfirmStep9 = false;
  public isConfirmStep10 = false;
  public isConfirmStep11 = false;
  public isConfirmStep12 = false;

  public isConfirmStep13 = false;
  public isConfirmStep14 = false;
  public isConfirmStep15 = false;
  public isConfirmStep16 = false;

  public isConfirmStep17 = false;
  public isConfirmStep18 = false;
  public isConfirmStep19 = false;
  public isConfirmStep20 = false;
  public isConfirmStep21 = false;
  public isConfirmStep22 = false;
  public isConfirmStep23 = false;
  public isConfirmStep24 = false;

  public isConfirmStep25 = false;
  public isConfirmStep26 = false;

 
  // --- computed --- //
  public get mainSocialNetworks() {
    // Возвращаем все сети кроме "Another"
    return this.socialNetworkList.slice(0, -1);
  }

  public get socialNetworkListWithoutTelegram() {
    return this.socialNetworkList.filter(network => network.value !== 'Telegram');
  }

  public get isBlock1Confirm() {
    // Проверяем основные поля
    if(!this.formData.name || !this.formData.surname || !this.formData.country || !this.formData.email) {
      return false;
    }
    
    // Проверяем чекбоксы подтверждения
    if(!this.isConfirmStep3 || !this.isConfirmStep4 || !this.isConfirmStep6 || !this.isConfirmStep7) {
      return false;
    }

    return this.isSocialNetworksSectionValid();
  }
  

  public get isBlock2Confirm() {
    return this.isConfirmStep8 && this.isConfirmStep9 && this.isConfirmStep10 && this.isConfirmStep11 && this.isConfirmStep12;
  }

  public get isBlock3Confirm() {
    return this.isConfirmStep13 && this.isConfirmStep14 && this.isConfirmStep15 && this.isConfirmStep16;
  }

  public get isBlock4Confirm() {
    return this.isConfirmStep17 && this.isConfirmStep18 && this.isConfirmStep19 && this.isConfirmStep20 && this.isConfirmStep21 && this.isConfirmStep22 && this.isConfirmStep23 && this.isConfirmStep24;
  }

  public get isBlock5Confirm() {
    return this.isConfirmStep25 && this.isConfirmStep26;
  }

  public get isSocialNetworkFilled() {
    return this.isSocialNetworksSectionValid();
  }

  // ---- RESIDENT --- //
  public get isResidentRole() {
    const role = this.userProfile?.role;
    return role === USER_ROLES.RESIDENT || role === USER_ROLES.RESIDENT_LIMITED;
  }

  private isSocialNetworksSectionValid(): boolean {
    

    const normalize = (v: string | null | undefined) => (v || '').trim();

    // 2) Основные соцсети:
    // - если ссылка пустая => должен быть отмечен skip
    // - если ссылка заполнена => skip должен быть снят
    const mainValid = this.formData.socials.every((s) => {
      const value = normalize(s.value);
      if (!value) {
        return s.skip === true;
      }
      return s.skip === false;
    });

    // 3) Дополнительные соцсети (добавленные пользователем) — если добавлены, то каждая должна быть заполнена
    const additionalValid = this.additionalSocials.every((s) => {
      const name = normalize(s.customName);
      const value = normalize(s.value);
      return Boolean(name) && Boolean(value);
    });

    // 4) Должна быть указана хотя бы одна соцсеть (основная или дополнительная)
    const hasAtLeastOne =
      this.formData.socials.some((s) => !s.skip && Boolean(normalize(s.value))) ||
      this.additionalSocials.some((s) => Boolean(normalize(s.customName)) && Boolean(normalize(s.value)));

      if(hasAtLeastOne) {
        return mainValid && additionalValid;
      } 
      
        // 1) Если выбран чекбокс "пропустить все соцсети" — секция валидна    
        return this.skipAllSocialNetworks && mainValid 
     
  }

  public get isBlock1FieldsDisabled() {
    /**
     * Требование:
     * - MODIFY: можно редактировать только block1
     * - NEW/REVIEW/CONFIRMED/REJECTED: нельзя редактировать ничего
     * - "": можно редактировать всё
     */
    if (this.residentAgreementStatus === '') return false;
    if (this.residentAgreementStatus === 'MODIFY') return false;
    return true;
  }

  public get isBlocks2to5Disabled() {
    /**
     * Требование:
     * - MODIFY: block2..block5 запрещены к редактированию
     * - NEW/REVIEW/CONFIRMED/REJECTED: запрещены
     * - "": разрешены
     */
    return this.residentAgreementStatus !== '';
  }

  public isSocialNetworkFieldDisabled(index: number): boolean {
    // Разрешаем редактирование только при статусе MODIFY
    if (this.residentAgreementStatus === 'MODIFY') {
      return false;
    }
    // Блокируем при статусе REVIEW
    if (this.residentAgreementStatus === 'REVIEW') {
      return true;
    }
    // Блокируем поле, если оно уже заполнено (и type, и value) и не пропущено
    const social = this.formData.socials[index];
    if (social && !social.skip && social.type && social.value && social.value.length > 0) {
      return true;
    }
    return this.isFormDisabled;
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public get isFormDisabled() {
    
    // При пустом статусе форма должна быть доступна для заполнения
    // Форма отключается если заявка уже отправлена, обработана или находится на проверке (REVIEW)
    return this.residentAgreementStatus === 'NEW' || 
           this.residentAgreementStatus === 'CONFIRMED' || 
           this.residentAgreementStatus === 'REJECTED' ||
           this.residentAgreementStatus === 'REVIEW';
  }

  public get isSubmitDisabled() {
    // Кнопка отправки отключается если заявка уже отправлена или обработана
    if(this.residentAgreementStatus === 'NEW' || this.residentAgreementStatus === 'CONFIRMED' || this.residentAgreementStatus === 'REJECTED') {
      return true;
    }
    // Кнопка отправки отключается если не все блоки заполнены
    if(!this.isBlock1Confirm || !this.isBlock2Confirm || !this.isBlock3Confirm || !this.isBlock4Confirm || !this.isBlock5Confirm) {
      return true;
    }
    // Если все блоки заполнены и статус позволяет - кнопка доступна
    return false;
  }

  // --- watchers --- //
  @Watch('userProfile.tg_username')
  public onTgUsernameChange(newValue: string | undefined) {
    // Если форма заблокирована, не заполняем поля автоматически
    if (this.isFormDisabled) {
      return;
    }
    
    // Находим индекс Telegram в массиве социальных сетей
    const telegramIndex = this.formData.socials.findIndex(s => s.type === 'Telegram');
    if (telegramIndex === -1) return;
    
    // Заполняем поля только если:
    // 1. Есть новое значение tg_username
    // 2. Поле value пустое и сеть не пропущена
    // Это позволяет автоматически заполнить поля при добавлении Telegram в UserProfileEdit
    if (newValue && !this.formData.socials[telegramIndex].value && !this.formData.socials[telegramIndex].skip) {
      this.formData.socials[telegramIndex].value = newValue;
    }
  }

  @Watch('userProfile.email')
  public onUserProfileEmailChange(newValue: string | undefined) {
    // Синхронизируем email без привязки к statusChanged.
    // Но не перетираем ручной ввод, если пользователь может редактировать форму и уже ввёл email.
    const next = (newValue || '').trim();
    if (!next) return;

    const current = (this.formData.email || '').trim();

    // Если email уже введён пользователем — не перезаписываем (когда форма доступна для ввода).
    if (current && !this.isFormDisabled && this.residentAgreementStatus === '') {
      return;
    }

    this.formData.email = next;
  }

  private syncEmailFromUserProfile(): void {
    const next = (this.userProfile?.email || '').trim();
    if (!next) return;

    const current = (this.formData.email || '').trim();
    if (current && !this.isFormDisabled && this.residentAgreementStatus === '') {
      return;
    }

    this.formData.email = next;
  }

  // --- methods --- //
  public async handleSendForConfirmation() {
   
    const confirmations = [
      this.isConfirmStep3,
      this.isConfirmStep4,
      this.isConfirmStep6,
      this.isConfirmStep7,
      this.isConfirmStep8,
      this.isConfirmStep9,
      this.isConfirmStep10,
      this.isConfirmStep11,
      this.isConfirmStep12,
      this.isConfirmStep13,
      this.isConfirmStep14,
      this.isConfirmStep15,
      this.isConfirmStep16,
      this.isConfirmStep17,
      this.isConfirmStep18,
      this.isConfirmStep19,
      this.isConfirmStep20,
      this.isConfirmStep21,
      this.isConfirmStep22,
      this.isConfirmStep23,
      this.isConfirmStep24,
      this.isConfirmStep25,
      this.isConfirmStep26,
    ];

    const hasUncheckedConfirmation = confirmations.some((value) => !value);

    if (hasUncheckedConfirmation) {
      this.$toast.error(this.$t("Please confirm all rules").toString());
      return;
    }

    // Проверка заполненности обязательных полей
    if (!this.formData.name || this.formData.name.trim().length === 0) {
      this.$toast.error(this.$t("Please fill in the Name field").toString());
      return;
    }

    if (!this.formData.country || this.formData.country.trim().length === 0) {
      this.$toast.error(this.$t("Please select a Country").toString());
      return;
    }

    // Проверка социальных сетей
    // Если не выбрано "пропустить все", то:
    // - каждая основная сеть должна быть либо заполнена, либо пропущена
    // - каждая добавленная дополнительная сеть должна быть заполнена (имя + ссылка)
    if (!this.skipAllSocialNetworks) {
      for (const social of this.formData.socials) {
        if (!social.skip && (!social.value || social.value.trim().length === 0)) {
          this.$toast.error(this.$t("Please fill in all social network fields or mark them as not used").toString());
          return;
        }
      }

      for (const social of this.additionalSocials) {
        if (!social.customName || social.customName.trim().length === 0) {
          this.$toast.error(this.$t("Please fill in all social network fields or mark them as not used").toString());
          return;
        }
        if (!social.value || social.value.trim().length === 0) {
          this.$toast.error(this.$t("Please fill in all social network fields or mark them as not used").toString());
          return;
        }
      }
    }
    
    // Фильтруем основные социальные сети - только те, что не пропущены и заполнены
    const mainSocials = this.formData.socials
      .filter(
        (social) => !social.skip && social.type && social.value && social.value.length > 0
      )
      .map(social => ({
        type: social.type,
        value: social.value
      }));

    // Дополнительные социальные сети - все добавленные (имя = type)
    const additionalSocials = this.additionalSocials
      .filter(s => s.customName && s.customName.length > 0 && s.value && s.value.length > 0)
      .map(s => ({
        type: s.customName,
        value: s.value
      }));

    // Объединяем массивы
    const allSocials = [...mainSocials, ...additionalSocials];

    const payload = {
      first_name: this.formData.name,
      last_name: this.formData.surname,
      country: this.formData.country,
      email: this.formData.email,
      socials: allSocials
    }
    console.log('send for confirmation')
    //console.log('handleSendForConfirmation', payload);
    const response = await dispatchSubmitResidentAgreement(this.$store, payload);
    if(response) {
      this.$toast.success(this.$t("Application sent for confirmation").toString());
    } else {
      this.$toast.error(this.$t("Error sending application").toString());
    }
    this.handleGetResidentAgreement();
    // console.log('response', response); // Application sent for confirmation
  }

  public async handleUpdateResidentAgreement() {

    const confirmations = [
      this.isConfirmStep3,
      this.isConfirmStep4,
      this.isConfirmStep6,
      this.isConfirmStep7,
      this.isConfirmStep8,
      this.isConfirmStep9,
      this.isConfirmStep10,
      this.isConfirmStep11,
      this.isConfirmStep12,
      this.isConfirmStep13,
      this.isConfirmStep14,
      this.isConfirmStep15,
      this.isConfirmStep16,
      this.isConfirmStep17,
      this.isConfirmStep18,
      this.isConfirmStep19,
      this.isConfirmStep20,
      this.isConfirmStep21,
      this.isConfirmStep22,
      this.isConfirmStep23,
      this.isConfirmStep24,
      this.isConfirmStep25,
      this.isConfirmStep26,
    ];

    const hasUncheckedConfirmation = confirmations.some((value) => !value);

    if (hasUncheckedConfirmation) {
      this.$toast.error(this.$t("Please confirm all rules").toString());
      return;
    }

    // Проверка заполненности обязательных полей
    if (!this.formData.name || this.formData.name.trim().length === 0) {
      this.$toast.error(this.$t("Please fill in the Name field").toString());
      return;
    }

    if (!this.formData.country || this.formData.country.trim().length === 0) {
      this.$toast.error(this.$t("Please select a Country").toString());
      return;
    }

    // Проверка социальных сетей
    if (!this.skipAllSocialNetworks) {
      for (const social of this.formData.socials) {
        if (!social.skip && (!social.value || social.value.trim().length === 0)) {
          this.$toast.error(this.$t("Please fill in all social network fields or mark them as not used").toString());
          return;
        }
      }

      for (const social of this.additionalSocials) {
        if (!social.customName || social.customName.trim().length === 0) {
          this.$toast.error(this.$t("Please fill in all social network fields or mark them as not used").toString());
          return;
        }
        if (!social.value || social.value.trim().length === 0) {
          this.$toast.error(this.$t("Please fill in all social network fields or mark them as not used").toString());
          return;
        }
      }
    }
    
    // Фильтруем основные социальные сети - только те, что не пропущены и заполнены
    const mainSocials = this.formData.socials
      .filter(
        (social) => !social.skip && social.type && social.value && social.value.length > 0
      )
      .map(social => ({
        type: social.type,
        value: social.value
      }));

    // Дополнительные социальные сети - все добавленные (имя = type)
    const additionalSocials = this.additionalSocials
      .filter(s => s.customName && s.customName.length > 0 && s.value && s.value.length > 0)
      .map(s => ({
        type: s.customName,
        value: s.value
      }));

    // Объединяем массивы
    const allSocials = [...mainSocials, ...additionalSocials];

    const payload = {
      request_id: this.residentAgreementRequestId,
      first_name: this.formData.name,
      last_name: this.formData.surname,
      country: this.formData.country,
      email: this.formData.email,
      socials: allSocials
    }
    // console.log('send update')
    const response = await dispatchUpdateResidentAgreement(this.$store, payload);
    if(response) {
      this.$toast.success(this.$t("Application sent for confirmation").toString());
    } else {
      this.$toast.error(this.$t("Error sending application").toString());
    }
    this.handleGetResidentAgreement();
  }

  public async handleGetResidentAgreement() {
    /**
     * NEW - новая ожидает подтверждения
     * CONFIRMED - подтвержденная
     * MODIFY - изменение
     * REVIEW - проверка
     * REJECTED - отклоненная
     */
    const response = await dispatchGetResidentAgreement(this.$store);
    if(response) {
      const newStatus = response.status;
      
      // Обновляем данные только если статус изменился
      const statusChanged = this.previousResidentAgreementStatus !== newStatus;
      
      this.residentAgreementStatus = "CONFIRMED" //newStatus;
      this.residentAgreementRequestId = response.id;

      // Email подтягиваем всегда (не зависит от statusChanged), чтобы избежать гонок при первом открытии.
      this.syncEmailFromUserProfile();
      
      // Обновляем данные формы только если статус изменился
      if (statusChanged) {
        if(this.residentAgreementStatus === 'NEW' || this.residentAgreementStatus === 'CONFIRMED') {
          this.fillFormConfirmData();

          this.formData.name = response.first_name ?? '';
          this.formData.surname = response.last_name ?? '';
          this.formData.country = response.country ?? this.formData.country;
          this.formData.email = this.userProfile?.email ?? '';
         
          // Загружаем социальные сети
          if(response.socials && response.socials.length === 0){
            this.skipAllSocialNetworks = true;
            this.handleSkipAllSocialNetworks();
          } else {
            this.skipAllSocialNetworks = false;
            this.loadSocialsFromResponse(response.socials || []);
          }
        }

        if(this.residentAgreementStatus === 'MODIFY' || this.residentAgreementStatus === 'REVIEW') {
          this.residentAgreementModifyReason = response.modify_comment;
          this.fillFormConfirmData();

          this.formData.name = response.first_name ?? '';
          this.formData.surname = response.last_name ?? '';
          this.formData.country = response.country ?? this.formData.country;
          this.formData.email = this.userProfile?.email ?? '';
          
          // Загружаем социальные сети
          if(response.socials && response.socials.length === 0){
            this.skipAllSocialNetworks = true;
            this.handleSkipAllSocialNetworks();
          } else {
            this.skipAllSocialNetworks = false;
            this.loadSocialsFromResponse(response.socials || []);
          }
        }

        if(this.residentAgreementStatus == "") {
          // Инициализируем социальные сети, если они еще не инициализированы
          if (this.formData.socials.length === 0) {
            this.initializeSocials();
          }
          
          this.formData.name = this.userProfile?.first_name ?? '';
          this.formData.surname = this.userProfile?.last_name ?? '';
          // this.formData.country = this.userProfile?.country ?? '';
          this.formData.email = this.userProfile?.email ?? '';
        }
      }
      
      // Сохраняем текущий статус как предыдущий для следующей проверки
      this.previousResidentAgreementStatus = newStatus;
      
      // Управляем интервалом проверки статуса в зависимости от нового статуса
      this.manageStatusCheckInterval();
      // console.log('residentAgreementRequestId', this.residentAgreementRequestId,response);
    }
    this.isLoadingStatus = false;
   // console.log('response', response);
  }

  public loadSocialsFromResponse(socials: Array<{type: string, value: string, customName?: string}>) {
    // Очищаем дополнительные сети
    this.additionalSocials = [];

    // Набор типов, найденных в ответе и применённых к основным сетям
    const seenTypes = new Set<string>();
    
    // Распределяем социальные сети по типам
    socials.forEach((social) => {
      // Ищем соответствующую основную сеть
      const index = this.formData.socials.findIndex(s => s.type === social.type);
      if (index !== -1) {
        this.formData.socials[index].value = social.value || '';
        this.formData.socials[index].skip = false;
        seenTypes.add(this.formData.socials[index].type);
        return;
      }

      // Иначе считаем это дополнительной соцсетью (type = название)
      this.additionalSocials.push({
        type: 'Another',
        value: social.value || '',
        customName: social.type || '',
      });
      this.isShowAddSocialNetwork = true;
    });

    // После распределения: отметить пропуск для тех основных соцсетей, которых нет в ответе
    this.formData.socials.forEach((s) => {
      // Исключаем 'Another' на всякий случай, хотя в основных его быть не должно
      if (s.type === 'Another') return;
      if (!seenTypes.has(s.type)) {
        s.value = '';
        s.skip = true;
      }
    });
    
    // Обновляем глобальный чекбокс
    this.updateSkipAllCheckbox();
  }

  public initializeSocials() {
    // Инициализируем массив социальных сетей на основе списка (кроме "Another")
    this.formData.socials = this.mainSocialNetworks.map(network => ({
      type: network.value,
      value: '',
      skip: false
    }));
  }

  
  public openEthicsCodeModal() {
    this.showECodexModal = true;
  }

  public handleCloseECodexModal() {
    this.showECodexModal = false;
  }

  public async handleConfirmStep3Change(event: Event) {
    const target = event.target as HTMLInputElement;
    const isChecked = target.checked;
    await dispatchGetUserProfile(this.$store);
    // Если пытаются установить чекбокс, проверяем наличие tg_username
    if (isChecked) {
      if (!this.userProfile?.tg_username) {
        // Показываем предупреждение
        this.showTgUsernameWarning = true;
        // Предотвращаем установку чекбокса
        target.checked = false;
        this.isConfirmStep3 = false;
        return;
      }
      // Если проверка прошла успешно, скрываем предупреждение
      this.showTgUsernameWarning = false;
    } else {
      // При снятии чекбокса скрываем предупреждение
      this.showTgUsernameWarning = false;
    }
    
    // Обновляем значение
    this.isConfirmStep3 = isChecked;
  }

  public async handleConfirmStep4Change(event: Event) {
    const target = event.target as HTMLInputElement;
    const isChecked = target.checked;
    await dispatchGetUserProfile(this.$store);
    // Если пытаются установить чекбокс, проверяем наличие telegramuser и статус 'A'
    if (isChecked) {
      if (!this.userProfile?.telegramuser || this.userProfile?.telegramuser?.status !== 'A') {
        // Показываем предупреждение
        this.showTelegramBotWarning = true;
        // Предотвращаем установку чекбокса
        target.checked = false;
        this.isConfirmStep4 = false;
        return;
      }
      // Если проверка прошла успешно, скрываем предупреждение
      this.showTelegramBotWarning = false;
    } else {
      // При снятии чекбокса скрываем предупреждение
      this.showTelegramBotWarning = false;
    }
    
    // Обновляем значение
    this.isConfirmStep4 = isChecked;
  }

  public fillFormConfirmData(){
    // Проверяем наличие tg_username перед установкой isConfirmStep3
    if (this.userProfile?.tg_username) {
      this.isConfirmStep3 = true;
      this.showTgUsernameWarning = false;
    } else {
      this.isConfirmStep3 = false;
      this.showTgUsernameWarning = false; // Не показываем предупреждение при загрузке формы
    }
    // Проверяем наличие telegramuser и статус 'A' перед установкой isConfirmStep4
    if (this.userProfile?.telegramuser && this.userProfile?.telegramuser?.status === 'A') {
      this.isConfirmStep4 = true;
      this.showTelegramBotWarning = false;
    } else {
      this.isConfirmStep4 = false;
      this.showTelegramBotWarning = false; // Не показываем предупреждение при загрузке формы
    }
    this.isConfirmStep6 = true
    this.isConfirmStep7 = true
    this.isConfirmStep8 = true
    this.isConfirmStep9 = true
    this.isConfirmStep10 = true
      this.isConfirmStep11 = true
    this.isConfirmStep12 = true
    this.isConfirmStep13 = true
    this.isConfirmStep14 = true
      this.isConfirmStep15 = true
      this.isConfirmStep16 = true
    this.isConfirmStep17 = true
      this.isConfirmStep18 = true
    this.isConfirmStep19 = true
      this.isConfirmStep20 = true
    this.isConfirmStep21 = true
    this.isConfirmStep22 = true
    this.isConfirmStep23 = true
    this.isConfirmStep24 = true
    this.isConfirmStep25 = true
    this.isConfirmStep26 = true
  }

  public handleGoBack() {
    this.$emit('go-back');
  }

  public handleAccordeonToggle(index: number, isOpen: boolean) {
    if (isOpen) {
      this.openAccordeonIndex = index;
    } else {
      this.openAccordeonIndex = null;
    }
  }

  public handleSkipAllSocialNetworks() {
    // Устанавливаем skip для всех основных социальных сетей
    this.formData.socials.forEach(social => {
      social.skip = this.skipAllSocialNetworks;
      if (this.skipAllSocialNetworks) {
        social.value = '';
      }
    });
    // Дополнительные соцсети нельзя "пропускать" по одной — при "пропустить все" просто очищаем список
    if (this.skipAllSocialNetworks) {
      this.additionalSocials = [];
      this.isShowAddSocialNetwork = false;
    }
  }

  public handleSkipSocialNetwork(index: number) {
    const social = this.formData.socials[index];
    if (social.skip) {
      // Если пропускаем, очищаем значение
      social.value = '';
    }
    // Проверяем, нужно ли обновить глобальный чекбокс
    this.updateSkipAllCheckbox();
  }

  public updateSkipAllCheckbox() {
    // Проверяем, все ли сети пропущены
    const allMainSkipped = this.formData.socials.every(s => s.skip);
    // Дополнительные соцсети не "пропускаются" — если они есть, то skipAll = false
    this.skipAllSocialNetworks = allMainSkipped && this.additionalSocials.length === 0;
  }

  public handleAddSocialNetwork() {
    // Добавляем новую дополнительную социальную сеть
    this.additionalSocials.push({
      type: 'Another',
      value: '',
      customName: '',
    });
    this.isShowAddSocialNetwork = true;
    // При добавлении доп. соцсети глобальный "пропустить все" не может быть активен
    this.skipAllSocialNetworks = false;
  }

  public handleRemoveAdditionalSocial(index: number) {
    // Удаляем дополнительную социальную сеть
    this.additionalSocials.splice(index, 1);
    if (this.additionalSocials.length === 0) {
      this.isShowAddSocialNetwork = false;
    }
    this.updateSkipAllCheckbox();
  }

  private async manageStatusCheckInterval() {
    // Останавливаем интервал, если он запущен
    if (this.statusCheckInterval !== null) {
      clearInterval(this.statusCheckInterval);
      this.statusCheckInterval = null;
    }

    // Если статус стал CONFIRMED — один раз обновим профиль пользователя
    if (this.residentAgreementStatus === 'CONFIRMED') {
      await dispatchGetUserProfile(this.$store);
    }

    // Запускаем интервал только для статусов: MODIFY, REVIEW, NEW
    const statusesToCheck = ['MODIFY', 'REVIEW', 'NEW'];
    if (statusesToCheck.includes(this.residentAgreementStatus)) {
      this.statusCheckInterval = window.setInterval(() => {
        this.handleGetResidentAgreement();
      }, 15000);
    }
    // Для CONFIRMED, REJECTED и пустого статуса интервал не запускается
  }

  // get countries list 
  public async getCountriesList() {
    /**
     * [
    {
        "code": "KZ",
        "name": "Казахстан"
    },
    {
        "code": "RU",
        "name": "Россия"
    },
    ...
     */
    const responseGetCountriesList = await dispAuthFetch(this.$store, {
      input: "/api/v1/accounts/countries_list/",
      init: {
        method: "GET",
      },
    });

    if (responseGetCountriesList.status === 200) {
      const countries = await responseGetCountriesList.json();
      const locale = this.$i18n?.locale || "ru";
      this.countryList = Array.isArray(countries)
        ? [...countries].sort((a, b) =>
            String(a?.name ?? "").localeCompare(String(b?.name ?? ""), locale, { sensitivity: "base" })
          )
        : countries;
    } else {
      this.$toast.error("Failed to get countries list, please try again later", {
        message: "Failed to get countries list, please try again later",
        duration: 3000,
        position: "bottom",
      });
    }
  }

  // ------------------------------------------------------------ //
  public async created() {
  // Инициализируем социальные сети
    this.initializeSocials(); // ← до mounted, до рендера
  }

  public async mounted() {
    
    
    await dispatchGetUserProfile(this.$store);
    // На всякий случай синхронизируем email сразу после загрузки профиля
    this.syncEmailFromUserProfile();
  
    await this.getCountriesList();

    // Получаем статус и управляем интервалом в зависимости от статуса
    await this.handleGetResidentAgreement();
  }

  public beforeDestroy() {
    // Очищаем интервал при уничтожении компонента
    if (this.statusCheckInterval !== null) {
      clearInterval(this.statusCheckInterval);
      this.statusCheckInterval = null;
    }
  }
}

export default ResidentRules;
